import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CollectionService} from '../services/shopify/collection.service';
import {ShopifyService} from '../services/shopify/shopify.service';
import {TSError} from 'ts-node';
import {SchedulerComponent} from '@progress/kendo-angular-scheduler';
import {Product} from '../models/product.model';
import {ScrollViewComponent} from '@progress/kendo-angular-scrollview';
@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html'
})
export class ProductListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('scroller', { static: false }) public scroller: ScrollViewComponent;

  products: Array<Product> = [];
  recommended: any[] = [];
  recommendedProducts: Product[] = [];
  storeLink: string = null;
  intervalId:any;

  constructor(
    private shopifyService: ShopifyService,
  ) {
    this.shopifyService.productsSubject.subscribe((data) => {
      this.products = data;
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    //this.intervalId = setInterval(() => this.scroller.next(), 4000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId)
  }
  encodedProductId(product:any) {
    return encodeURIComponent(product ? product.id : '');
  }

}
